window.theme = window.theme || {};

var $body = $('body'),
    $productSlider = $('.product-image-slider'),
    $productModalSlider = $('.product-modal-slider'),
    $productModal = $productModalSlider.parents('.modal');

theme.createProductImgCarousel = function () {
  theme.initSlider($('.product-image-slider'), {dots: true, enabledMobileCarousel: true, prevNextButtons: false});
};

theme.createModalCarousel = function (modalIndex) {
  theme.initSlider('.product-modal-slider', { initialIndex: modalIndex, isSmooth: false });
};

$(function($) {
  if (window.innerWidth < 768) {
    theme.createProductImgCarousel();
  } else {
    $('.product-image-single:not(.no-zoom)').on('click', function() {
      var modalIndex = $(this).attr('data-index');
      $productModal.addClass('is-active');
      theme.createModalCarousel(modalIndex);
      $body.css({'overflow': 'hidden', 'height': '100vh'});
    });

    $productModal.find('.modal-close').on('click', function() {
      $productModal.removeClass('is-active');
      $body.css({'overflow': 'initial', 'height': 'initial'});
    });

    $("[class^='thumbnail-']" ).on('click', function() {
      $('html').animate({
          scrollTop: $('.image-' + $(this).data('index')).offset().top
      }, 700);
    });

    var imageHeight = $('.image-0').innerHeight();
    var imageCount = $productSlider.children().length;
    var offset = 145;

    $(window).on('scroll', function(){
      var scrollTop = $(window).scrollTop();
      $('.border-active').removeClass('border-active');
      for (var i = 0; i < imageCount / 2; i++) {
        var firstThumbnailClass = '.thumbnail-' + (i * 2).toString();
        var secondThumbnailClass = '.thumbnail-' + (i * 2 + 1).toString();
        var newIndex = i + 1;
        var topOffset = i === 0 ? 0 : offset;
        if(scrollTop < (imageHeight * newIndex) + offset && scrollTop >= (imageHeight * i) + topOffset) {
          $(firstThumbnailClass).addClass('border-active');
          $(secondThumbnailClass).addClass('border-active');
        }
      }
    }).trigger('scroll');
  }

  var pageHandle = window.location.pathname.split('/').pop();
  $('.js-product-video-btn').each(function() {
    var $parent = $(this).parent();
    $parent.on('click', function (event){
      var $this = $(this);
      event.preventDefault();
      if($this.hasClass('product-video-playing')){
        $this.find('video')[0].pause();
        $this.removeClass('product-video-playing');
      } else {
        $this.find('video')[0].play();
        $this.addClass('product-video-playing');

      }
    });
  });
});

